import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "partner-analyses-list" } },
    _vm._l(_vm.partner.analyses, function (analysis, index) {
      return _c(
        "div",
        {
          key: `${analysis.id}-${analysis.analysis_synonym_id}-${index}`,
          staticClass: "mb-4",
          attrs: { "data-qa": "partner-analyses-card" },
        },
        [
          _c(_setup.AnalysisCard, {
            staticClass: "mb-4",
            attrs: {
              analysis: analysis,
              partner: _vm.partner,
              "show-cart-button": _vm.showCartButton,
              "show-is-duplicate-description": _vm.showIsDuplicateDescription,
              "show-is-analysis-active-status": _vm.showIsAnalysisActiveStatus,
              "disable-cart-button": _vm.disableCartButton,
            },
            on: {
              "click:add-to-cart": function ($event) {
                return _setup.emit("click:add-to-cart", analysis)
              },
              "click:delete-from-cart": function ($event) {
                return _setup.emit("click:delete-from-cart", analysis)
              },
            },
          }),
          _vm._v(" "),
          index !== _vm.partner.analyses.length - 1
            ? _c(VDivider)
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }